import React, { Component } from 'react'

export default class ButtonToggle extends Component {
  constructor ( props ) {
    super( props );
  }

  _handleChange () {
    if (typeof this.props.handleChange == 'function') {
      this.props.handleChange(!this.props.isChecked);
    }
  }

  render () {
    const { className, text } = this.props
    return(
      <div className={`${className || ''} buttontoggle`}>
        <div className="buttontoggle-switch-container">
            <label>
                <input ref="switch" checked={ this.props.isChecked } onChange={this._handleChange.bind(this)} className="switch" type="checkbox" />
                <div>
                  <div></div>
                </div>
                <content className={this.props.isChecked ? "c-checked" : ""}>{text}</content>
            </label>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/controls/_ButtonToggle.js